import { render } from "./Residential.vue?vue&type=template&id=36c528c5"
import script from "./Residential.vue?vue&type=script&lang=js"
export * from "./Residential.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__